import type { MaybeRefOrGetter } from 'vue';
import type { ResolvedMonospaceCollection } from '#layers/data-model/types/schema/resolved-schema';
import { computed, toValue } from 'vue';
import { getCollectionDefaultDisplayTemplate, isEmptyDisplayTemplate } from '#layers/data-model/utils/display-template';

export function useCollectionDisplayTemplate(collection: MaybeRefOrGetter<ResolvedMonospaceCollection>) {
	const defaultDisplayTemplate = computed(() => getCollectionDefaultDisplayTemplate(toValue(collection)));

	return computed(() => {
		const collectionDisplayTemplate = toValue(collection).meta?.displayTemplate;
		return isEmptyDisplayTemplate(collectionDisplayTemplate) ? defaultDisplayTemplate.value : collectionDisplayTemplate;
	});
}
